import { render, staticRenderFns } from "./LabelDocDownloadLink.vue?vue&type=template&id=55fbe954"
import script from "./LabelDocDownloadLink.vue?vue&type=script&lang=js"
export * from "./LabelDocDownloadLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports